import { render, staticRenderFns } from "./power.vue?vue&type=template&id=70e7c7e5&scoped=true&"
import script from "./power.vue?vue&type=script&lang=js&"
export * from "./power.vue?vue&type=script&lang=js&"
import style0 from "./power.vue?vue&type=style&index=0&id=70e7c7e5&lang=less&scoped=true&"
import style1 from "./power.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7c7e5",
  null
  
)

export default component.exports